import { render } from "./defaultModal.vue?vue&type=template&id=3b2b091a"
import script from "./defaultModal.vue?vue&type=script&lang=js"
export * from "./defaultModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__